function accounts(backendAxiosInstance) {
  async function logout(accessTokenData, headers = {}) {
    return backendAxiosInstance.post(
      "/customer/v1/accounts/logout",
      accessTokenData,
      { headers }
    );
  }
  return {
    logout
  };
}

export { accounts as default };
//# sourceMappingURL=accounts.js.map
